export const ROLES={
    core_Validator:"Core Validator",
    technical_validator:"Technical Validator",
    business_validator:"Business Validator",
    pricing:"Pricing",
    RA:"Committee",
    committee:"Assessment Reviewer",
    
    // Assessment Reviewer Roles (6 specialized roles)
    bioequivalence_validation: "Assessment Bioequivalence Validation",
    quality_validation: "Assessment Quality Validation",
    pharmacovigilance: "Assessment Pharmacovigilance",
    clinical_validation: "Assessment Clinical Validation",
    control_lab_validation: "Assessment Control lab Validation",
    inspection_department: "Assessment Inspection Department",
}